import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AppConfigService } from '@app/app-config.service';
import { AppStore } from '@app/app.store';
import { LoginSamlService } from '@app/features/auth/services/login.saml.service';
import { LoginStateService } from '@app/features/auth/services/login.state.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    @Inject('LoginStateService') protected loginStateService: LoginStateService,
    @Inject('LoginSamlService') protected loginSamlService: LoginSamlService,
    protected http: HttpClient,
    protected appConfigService: AppConfigService,
    private router: Router,
    protected appStore: AppStore
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.loginStateService.isTokenValid()) {
      return true;
    }
    if (this.appConfigService.isAdfsActive()) {
      this.loginSamlService.redirect();
    } else {
      this.router.navigate(['/auth/login']);
    }
    this.loginStateService.closeSession();
    return false;
  }
}
